import angular from 'angular';
import SearchController from "./search-controller";
import SearchService from "./search-service";
import SearchConfig from "./search-directive";
import searchResults from "./searchresults-directive";

let Search = angular
    .module('Search', [])
    .controller('SearchController', SearchController)
    .service('SearchService', SearchService)
    .directive('searchConfig', ['SearchService', (SearchService) => new SearchConfig(SearchService)])
    .directive('searchResults', searchResults);
export default Search;

